import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRefetchOnAliveUpdate, type PullRequestAliveData} from './use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from './use-invalidate-on-alive-update'
import {useReviewRequestsQuery} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.reviewers_updated)

export function useReviewersLiveUpdates(aliveChannels: AliveChannels): void {
  const {refetch, queryKey} = useReviewRequestsQuery()
  const dedupeConcurrentRefetches = isFeatureEnabled('merge_status_checks_refetch_dedupe')

  // Original refetch path (flag OFF)
  useRefetchOnAliveUpdate(dedupeConcurrentRefetches ? '' : aliveChannels.pullRequest, refetch, {
    reviewers_updated: true,
  })
  useRefetchOnAliveUpdate(dedupeConcurrentRefetches ? '' : aliveChannels.pullRequestState, refetch)

  // Additive dedupe path (flag ON). pullRequestsState subscription is no longer necessary because reviwers_updated
  // is correctly dispatched in those events
  useInvalidateOnAliveUpdate(dedupeConcurrentRefetches ? aliveChannels.pullRequest : '', queryKey, {
    filter,
  })
}
